import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import forrestCar from '../../images/sustainaCar.jpg';

const useStyles = makeStyles({
  container: {
    justifyContent: 'space-between',
    marginTop: 80,
    marginBottom: 40,
    '@media (max-width:600px)': {
      flexDirection: 'column-reverse',
      marginTop: 40,
      marginBottom: 0,
    },
  },
  imageGrid: {
    padding: '0px 0px 0px 100px',
    '@media (max-width:900px)': {
      padding: '0px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '0px 0px 20px 0px',
    },
  },
  textGrid: {
    padding: '0px 0px 0px 160px',
    maxWidth: 720,
    '@media (max-width:1024px)': {
      padding: '20px 0px 40px 100px',
    },
    '@media (max-width:900px)': {
      padding: '20px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '20px 20px 20px 20px',
    },
  },
});
const SustainabilityPage = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item sm={6} className={classes.textGrid}>
        <h3 style={{ marginTop: 0 }}>Corporate Social Responsibility</h3>
        <p style={{ paddingRight: 32, maxWidth: 600 }}>
          We define corporate responsibility as achieving commercial
          profitability in a way that is consistent with fundamental ethical
          values and with respect for individuals, the environment and society.
          This is further explained in our social responsibility guidelines,
          which are reviewed and revised on an annual basis and included in our
          annual report. According to these guidelines, Vow will respect human
          and labour rights, establish good environmental, health and safety
          (EHS) standards, facilitate good dialogue with stakeholders and
          generally operate in accordance with applicable regulatory frameworks
          and good business practice. Our business depends on the trust of
          consumers, contractual parties, the authorities, shareholders,
          employees and society in general. In order to gain trust, we depend
          upon professionalism, expertise and high ethical standards in all
          aspects of our work.
        </p>
      </Grid>
      <Grid item sm={6} className={classes.imageGrid}>
        <img src={forrestCar} alt="vow sustainability" />
      </Grid>
    </Grid>
  );
};

export default SustainabilityPage;
